import {
	Component,
	OnInit,
	Inject,
	Input,
	Output,
	EventEmitter,
	OnChanges,
	SimpleChanges,
} from "@angular/core";
import { OnDestroyedDirective } from "app/shared/components/on-destroyed-component";
import { Observable, Subscription, fromEvent } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "form-tabs",
    templateUrl: "./form-tabs.component.html",
    styleUrls: ["./form-tabs.component.scss"],
    standalone: false
})
export class FormTabsComponent
	extends OnDestroyedDirective
	implements OnInit, OnChanges {
	_activeTab;
	@Input() tabs:
		| string[]
		| [
				{id?: string;
					name: string;
					icon: string;
					iconLeftMargin?: number;
					disabledIcon?: string;
				}
			] = [];
		@Input() width: string;
	@Input() _disabled: boolean;
	@Input() setActiveTab: string;
	@Input() responsiveTabs: string[] = [];
	@Output() tabChanged = new EventEmitter<any>();
	resizeObservable$: Observable<Event>;
	resizeSubscription$: Subscription;
	screenWidth: number;
	constructor() {
		super();
	}
	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		// tslint:disable-next-line: no-string-literal
		this._activeTab = this._activeTab
			? this._activeTab
			: this.tabs[0]["name"]
			? this.tabs[0]["name"]
			: this.tabs[0];
		this.resizeObservable$ = fromEvent(window, "resize");
		this.resizeSubscription$ = this.resizeObservable$
			.pipe(takeUntil(this.unsubscribeAll))
			.subscribe((evt) => {
				this.screenWidth = window.innerWidth;
			});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes?.setActiveTab?.currentValue?.length > 0) {
			this._tabChanged(changes.setActiveTab.currentValue);
		}
	}

	_tabChanged(value: string | { name: string; icon: string } | { id: string; name: string; icon: string }): void {
		if (!this._disabled) {
			// tslint:disable-next-line: no-string-literal
			this._activeTab = value["id"] ? value["id"] : (value["name"] ? value["name"] : value);
			this.tabChanged.emit(value);
		}
	}
}
